/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { h } from "@stencil/core";
import { getIconScale } from "../../utils/component";
export const CSS = {
    button: "x-button",
};
export const XButton = ({ disabled, key, label, scale, }) => (h("button", { "aria-label": label, class: CSS.button, disabled: disabled, key: key, tabIndex: -1, type: "button" }, h("calcite-icon", { icon: "x", scale: getIconScale(scale) })));
//# sourceMappingURL=XButton.js.map
